export function formatMoney(value: number, currency: string, locale = "en-US", maximumFractionDigits = 0): string {
  const code = currency.trim().toUpperCase();
  if (!/^[A-Z]{3}$/.test(code)) throw new Error(`Invalid ISO currency code: ${currency}`);
  const effectiveLocale = code === "USD" ? "en-US" : locale;
  return new Intl.NumberFormat(effectiveLocale, {
    style: "currency",
    currency: code,
    currencyDisplay: "narrowSymbol",
    minimumFractionDigits: 0,
    maximumFractionDigits,
  }).format(value);
}

export const MONEY_RANGE_SEPARATOR = " \u2013 ";

/** Parts let the shared renderer isolate each amount without changing currency placement. */
export function formatMoneyRangeParts(
  low: number,
  high: number,
  currency: string,
  locale = "en-US",
  maximumFractionDigits = 0,
) {
  return {
    low: formatMoney(low, currency, locale, maximumFractionDigits),
    separator: MONEY_RANGE_SEPARATOR,
    high: formatMoney(high, currency, locale, maximumFractionDigits),
  };
}

export function formatMoneyRange(
  low: number,
  high: number,
  currency: string,
  locale = "en-US",
): string {
  const parts = formatMoneyRangeParts(low, high, currency, locale);
  return parts.low + parts.separator + parts.high;
}
